import React, { useEffect, useState } from "react";
import AuthPage from "./AuthPage";
import { getNewToken } from "../../utils/handleJWT";

const AuthGuard = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [validating, setValidating] = useState(false);
  const [validationError, setValidationError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      setValidating(true);
      getNewToken().then((result) => {
        setValidating(false);
        if (result.success) {
          setIsAuthenticated(true);
        } else {
          if (result.shouldLogout) {
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            setIsAuthenticated(false);
          } else {
            setValidationError(
              "به دلیل مشکلات اینترنت، اعتبار سنجی به درستی انجام نشده و عملکرد برنامه ممکنه با اختلالاتی همراه باشه"
            );
            setIsAuthenticated(true);
          }
        }
      });
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  if (validating) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          background: "#0f0f0f",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div className="loading-spinner"></div>
        <p style={{ color: "#ffffff", fontSize: "1.1rem" }}>
          در حال اعتبار سنجی
        </p>
      </div>
    );
  }

  if (isAuthenticated === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          background: "#0f0f0f",
        }}
      >
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <>
      {validationError && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            background: "#e74c3c",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.75rem 1rem",
            zIndex: 9999,
            fontSize: "0.9rem",
            gap: "0.75rem",
          }}
        >
          <span>{validationError}</span>
          <button
            onClick={() => setValidationError(null)}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              fontSize: "1.2rem",
              lineHeight: 1,
              padding: "0",
              flexShrink: 0,
            }}
          >
            &times;
          </button>
        </div>
      )}
      {isAuthenticated ? children : <AuthPage />}
    </>
  );
};

export default AuthGuard;
